<template>
  <div class="public-layout">
    <PublicHeader @toggle-drawer="handleDrawerToggle" v-if="hostname === 'nexgbits-hosting.com'" />
    <PublicHeaderGeneric @toggle-drawer="handleDrawerToggle" v-else />
       <v-navigation-drawer
        v-model="drawerx"
        temporary
        width="400"
        class="mobile-navigation-drawer"
      >
        <MegaMobile
          v-if="smAndDown"
          class="mobile-mega-menu"
         
        />
      </v-navigation-drawer>

    <main class="public-content">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </main>

  <AppFooter />
  </div>
</template>


<script setup>
import { ref, onMounted, computed } from "vue";
import PublicHeader from "../components/PublicHeader.vue";
import PublicHeaderGeneric from "../components/PublicHeaderGeneric.vue";
import AppFooter from "@/components/AppFooter.vue";
import publicApi from "@/auth/publicApi";

import MegaMobile from "../pages/MegaMobile.vue";
///Test all again. The test again. testing again. test again sdfsdfds

import { useLangStore } from '@/store/lang'
import { useThemeStore } from "@/store/auth"
import { useI18n } from 'vue-i18n'

import { useDisplay } from 'vuetify'
const { mdAndUp, smAndDown } = useDisplay()

 const hostname =
    window.location.hostname
      ?.trim()
      .toLowerCase();

const lang = useLangStore()
const themeStore = useThemeStore()
const theme = computed(() => themeStore.themeStyles)

const getDisplaySettings = ref([])

const { t, locale } = useI18n()
const drawerx = ref(false)

PublicHeaderGeneric

function handleDrawerToggle() {
  drawerx.value = !drawerx.value
}

const drawerWidth = computed(() => {
  return window.innerWidth < 400
    ? window.innerWidth
    : 400
})

onMounted(async () => {
  console.log("PublicLayout mounted");

  const resp = await publicApi.get('/PageDisplaySetting/search', {
        params: { filterText: 'homePage' }
      })
      getDisplaySettings.value = resp.data[0]
      console.log("Mobile data", resp.data)
  });
</script>

<style scoped>
.public-layout {
  display: flex;
  flex-direction: column;

  width: 100%;
  max-width: 100%;
  min-width: 0;

  min-height: 100vh;

  box-sizing: border-box;

  overflow-x: clip;
}

.public-content {
  flex: 1 1 auto;

  width: 100%;
  max-width: 100%;
  min-width: 0;

  box-sizing: border-box;
}

:deep(.mobile-navigation-drawer) {
  top: 0 !important;
}

.mobile-mega-menu {
  margin-top: relative;
  padding-top: 0 !important;
}

@media (max-width: 430px) {
  :deep(.mobile-navigation-drawer) {
    top: 128px !important;
    height: calc(100vh - 128px) !important;
  }

  .mobile-mega-menu {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
}
/* .public-content {
  flex: 1;
} */
</style>